import Box from "ds/components/Box";
import Tab from "ds/components/Tab";
import Badge from "ds/components/Badge";

import { NavigationItem } from "./types";

type ViewHeaderNavigationItemsProps = {
  items: NavigationItem[];
};

const ViewHeaderNavigationItems = ({ items }: ViewHeaderNavigationItemsProps) => {
  return (
    <>
      {items.map((item) => (
        <Tab
          end={item.exact}
          key={item.key}
          to={item.link}
          label={
            item.beta ? (
              <Box gap="medium" align="center">
                {item.title}
                <Badge variant="green" type="strong" text="BETA" />
              </Box>
            ) : (
              item.title
            )
          }
        />
      ))}
    </>
  );
};

export default ViewHeaderNavigationItems;
